import Vue from 'vue'
import VueDraggable from 'vuedraggable'

Vue.component('draggable', VueDraggable)
